import React from 'react';

import Button from '@atlaskit/button/default/button';
import { cssMap } from '@atlaskit/css';
import { CloseButton } from '@atlaskit/modal-dialog/close-button';
import ModalBody from '@atlaskit/modal-dialog/modal-body';
import ModalFooter from '@atlaskit/modal-dialog/modal-footer';
import ModalHeader from '@atlaskit/modal-dialog/modal-header';
import ModalTitle from '@atlaskit/modal-dialog/modal-title';
import { Flex } from '@atlaskit/primitives/compiled/flex';
import { Text } from '@atlaskit/primitives/compiled/text';

import { type ErrorFallbackProps } from './types';

const styles = cssMap({
	flex: {
		flexDirection: 'row-reverse',
		width: '100%',
	},
});

// TODO: Add i18n once flag `platform_dst-a11y_accessible-error-modal` lands
export const ErrorFallback = ({ error: _, closeModal }: ErrorFallbackProps): React.JSX.Element => {
	return (
		<>
			<ModalHeader>
				<Flex gap="space.200" justifyContent="space-between" xcss={styles.flex}>
					<Flex justifyContent="end">{closeModal && <CloseButton onClick={closeModal} />}</Flex>
					<ModalTitle appearance="danger">
						{/* TODO: Add i18n once flag `platform_dst-a11y_accessible-error-modal` lands */}
						Couldn't load dialog content
					</ModalTitle>
				</Flex>
			</ModalHeader>
			<ModalBody>
				<Text as="p">
					{/* TODO: Add i18n once flag `platform_dst-a11y_accessible-error-modal` lands */}
					Something went wrong while loading the dialog content. Dismiss to go back
				</Text>
			</ModalBody>
			<ModalFooter>
				<Button appearance="primary" onClick={closeModal}>
					{/* TODO: Add i18n once flag `platform_dst-a11y_accessible-error-modal` lands */}
					Close
				</Button>
			</ModalFooter>
		</>
	);
};
